// extracted by mini-css-extract-plugin
module.exports = {"select-lab-order-dialog":"select-lab-order-dialog-36b41a14c8eaf0568d406233bca90c25"};